import { FC, PropsWithChildren } from 'react';

import clsx from 'clsx';

import css from './Card.module.css';

import { WithClassName } from 'v2/types';

export const Card: FC<PropsWithChildren<WithClassName>> = ({ className, children }) => (
  <div className={clsx(css.card, className)}>{children}</div>
);
